module.exports = __webpack_public_path__ + "img/icon-tiktok.a486a573.svg";